<div class="container-fluid h-100">

    <!-- center content -->
    <div class="invisible col-md-1 fixed"></div>
    <div class="col fluid d-flex flex-column p-0">
        <nav id="topNav" class="navbar navbar-expand-md fixed-top bg-light navbar-p" style="color: black;">
            <a href="home"><img src="assets/images/logo.png" class="responsive"></a>
            <button class="navbar-toggler ml-auto py-2" type="button" data-toggle="collapse"
                data-target="#collapsingNavbar">
                ☰
            </button>  
            <div class="collapse navbar-collapse nav-m-l" id="collapsingNavbar">
                <ul class="nav navbar-nav navbar-m-styles">
                    <div class="left-panel-view">
                        <li class="nav-item left_panel-li-iphone-style" data-toggle="tooltip" data-placement="right" title="Dashboard" [routerLinkActive]="['class1']">
                            <a class="nav-link left_panel-iphone-style" routerLink="/dashboard">
                                <img src="assets/images/dashboard.svg" style="width: auto; height: auto;">&nbsp;
                                <span class="nav-link-text sidebar-text" [routerLinkActive]="['class1']">Dashboard</span>
                            </a>
                        </li>
                    
                        <li class="nav-item left_panel-li-iphone-style" data-toggle="tooltip" routerLink="/basic"  [routerLinkActive]="['class1']" data-placement="right" title="Basic Information">
                            <a class="nav-link left_panel-iphone-style"  >
                                <img src="assets/images/information.svg" style="width: auto; height: auto;">&nbsp;
                                <span class="nav-link-text sidebar-text" [routerLinkActive]="['class1']">Basic Information</span>
                            </a>
                        </li>
                        <li class="nav-item left_panel-li-iphone-style" data-toggle="tooltip" data-placement="right" title="My Documents" [routerLinkActive]="['class1']">
                            <a class="nav-link left_panel-iphone-style" routerLink="/documents">
                                <img src="assets/images/doc.svg" style="width: auto; height: auto;">&nbsp;
                                <span class="nav-link-text sidebar-text" [routerLinkActive]="['class1']">My Documents</span>
                            </a>
                        </li>
                        <li class="nav-item left_panel-li-iphone-style" data-toggle="tooltip" data-placement="right" title="Download Tax Return" [routerLinkActive]="['class1']">
                            <a class="nav-link left_panel-iphone-style" routerLink="/download" >
                                <img src="assets/images/tax.svg" style="width: auto; height: auto;">&nbsp;
                                <span class="nav-link-text sidebar-text" [routerLinkActive]="['class1']">Download Tax Return</span>
                            </a>
                        </li>
                        <li class="nav-item left_panel-li-iphone-style" data-toggle="tooltip" data-placement="right" title="Make Payment" [routerLinkActive]="['class1']">
                            <a class="nav-link left_panel-iphone-style" routerLink="/payment">
                                <img src="assets/images/payment.svg" style="width: auto; height: auto;">&nbsp;
                                <span class="nav-link-text sidebar-text" [routerLinkActive]="['class1']">Make A Payment</span>
                            </a>
                        </li>
                        <li class="nav-item left_panel-li-iphone-style" data-toggle="tooltip" data-placement="right" title="Consent Of Disclosure" [routerLinkActive]="['class1']">
                            <a class="nav-link left_panel-iphone-style" routerLink="/disclosure">
                                <img src="assets/images/disclosure.svg" style="width: auto; height: auto;">&nbsp;
                                <span class="nav-link-text sidebar-text" [routerLinkActive]="['class1']">Consent Of Disclosure</span>
                            </a>
                        </li>
                    </div>

                    <li class="nav-item nav-styles header-view-mobile m-b-ipad m-b-1280" *ngIf="!fileNo">
                        <a class="nav-link nav-link-styles font-size-ipad">File No : 0 </a>   
                    </li>

                    <li class="nav-item nav-styles header-view-mobile m-b-ipad m-b-1280" *ngIf="fileNo">
                        <a class="nav-link nav-link-styles font-size-ipad">File No : {{fileNo}}</a>   
                    </li>

                    <li class="nav-item nav-styles header-view-mobile m-b-ipad m-b-1280">
                        <a class="nav-link nav-link-styles change-color" >Status : New Registered </a>
                    </li>

                    <li class="nav-item nav-styles header-view-mobile m-b-ipad m-b-1280">
                        <a class="nav-link nav-link-styles change-color" href="/pricing" target="_blank" >Fee Shedule </a>
                    </li>



                    <li class="nav-item nav-styles header-view-mobile m-b-ipad m-b-1280">
                        <a class="nav-link nav-link-styles" href="/refund" target="_blank">Refund Status</a>
                    </li>

                    <!-- <li class="nav-item nav-styles">
                        <a class="nav-link nav-link-styles change-color" href="changePassword" >Change Password</a>
                    </li> -->

                    <li class="nav-item nav-refer-styles header-view-mobile">

                            <a class="" routerLink="/changePassword" ><button class="btn btn-outline-warning btn-color-styles">
                                    Change Password</button></a>
                        </li>
                    <!-- <li class="nav-item">
                                <a class="nav-link" style="width: 100px; color: black;" (click)="logout()" data-toggle="modal" data-target="#logoutModel">
                                <i class="fa fa-fw fa-sign-out"></i>Logout</a>
                            </li> -->
                    <li class="nav-item nav-refer-styles header-view-mobile">

                        <a class="" routerLink="/refer-friend" ><button class="btn btn-outline-warning btn-color-styles">
                                Refer A Friend</button></a>
                    </li>
  
                    <li class="nav-item">
                        <button class="btn btn-outline-warning btn-color-styles" data-toggle="modal"
                            data-target="#myModal"> <img src="assets/images/logout-img.png" style="width: 20px;">
                            Logout</button>
                    </li>


                </ul>
                <!-- <ul class="nav navbar-nav ml-auto">
                            <li class="nav-item">
                                <a class="nav-link" style="width: 100px;" href="javascript:void(0);" onclick="logout()" data-toggle="modal" data-target="#logoutModel">
                                <i class="fa fa-fw fa-sign-out"></i>Logout</a>
                            </li>
                        </ul> -->
            </div>
        </nav>

        <!-- main content -->

        <!-- /main content -->
        <!-- <div style="position: absolute">
            <div class="modal" id="changeModal">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="container">
                            <div class="modal-body">
                                <form [formGroup]="form" class="form-styles"
                                    data-backdrop="false">
                                    <div class="form-group">
                                        <div class="form-row">
                                            <div class="col-md">
                                                <label for="first">Your Name</label>
                                                <input type="first" class="form-control" id="first" name="first"
                                                    placeholder="{{userName}} " value="{{userName}}" disabled readonly>
                                            </div>
                                        </div><br>
                                        <div class="form-row">
                                            <div class="col-md">
                                                <label for="email">Email</label>
                                                <input type="email" class="form-control" id="email" name="email"
                                                    value="{{userEmail}}" placeholder="{{userEmail}}" disabled readonly>
                                            </div>
                                        </div><br>
                                    </div>

                                    <div class="form-group">
                                        <div class="form-row">

                                            <div class="col-md">
                                                <label for="passwordNew">New Password</label>
                                                <input type="text" class="form-control"
                                                    pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
                                                    id="password" name="password" formControlName="new_password"
                                                    value="{{new_password}}">
                                            </div>

                                            <div></div>
                                        </div><br>

                                        <div class="form-row">

                                            <div class="col-md">
                                                <label for="passwordCnf">Confirm Password</label>
                                                <input type="text" class="form-control"
                                                    pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
                                                    id="cnfpassword" name="cnfpassword" formControlName="cnf_password"
                                                    value="{{cnf_password}}">
                                            </div>

                                            <div></div>
                                        </div>
                                    </div>

                                    <div class="modal-footer">
                                        <button class="btn btn-styles btn-primary" type="submit"
                                            [disabled]="!form.valid" data-backdrop="false">Submit</button>
                                        <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div> -->
        <!-- Modal for Change Password
        <div class="modal1" id="changeModal1">
            <div class="modal-dialog1">
                <div class="modal-content1">

                    Modal Header
                    <div class="modal-header">
                        <h4 class="modal-title">Change Password</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    Modal body
                    <div class="modal-body">
                        
                            <div class="form-group">
                                <label for="email">Email</label>
                                <input type="email" class="form-control" id="email" name="email" ngModel
                                    #emailref="ngModel" [(ngModel)]="this.userEmail" disabled>
                            </div>

                            <div class="form-group">
                                <label for="email">User Name</label>
                                <input type="text" class="form-control" id="user" name="user" ngModel #userref="ngModel"
                                    [(ngModel)]="this.userName" disabled>
                            </div>
                            <div class="form-group">
                                <label for="passwordNew">New Password</label>
                                <input type="text" class="form-control"
                                    pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
                                    id="password" name="password" ngModel #passwordref="ngModel"
                                    [(ngModel)]="new_password" required>
                                <div *ngIf="passwordref.errors &&(passwordref.touched || passwordref.dirty)"
                                    class="alert alert-danger">
                                    <div [hidden]="!passwordref.errors?.pattern">
                                        UpperCase, LowerCase, Number/SpecialChar and min 8 Chars
                                    </div>
                                </div>
                                
                            </div>
                            <div class="form-group">
                                <label for="passwordC">Confirm Password</label>
                                <input type="text" class="form-control"
                                    pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
                                    id="passwordC" name="passwordC" ngModel #passwordCref="ngModel"
                                    [(ngModel)]="cnf_password" required>
                                <div *ngIf="passwordCref.errors &&(passwordCref.touched || passwordCref.dirty)"
                                    class="alert alert-danger">
                                    <div [hidden]="!passwordCref.errors?.pattern">
                                        UpperCase, LowerCase, Number/SpecialChar and min 8 Chars
                                    </div>
                                </div>
                            </div>
                        
                    </div>

                    Modal footer
                    <div class="modal-footer" style="text-align: center;">
                        <button type="button" (click)="changePwd()" class="btn btn-success"
                            data-dismiss="modal">Confirm</button>
                        <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                    </div>

                </div>
            </div>
        </div> -->


        <!-- Modal for Logout -->
        <div class="modal" id="myModal">
            <div class="modal-dialog modal-logout-width">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title title-logout-left">Are You Sure</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body modal-logout-left">
                        Do You Want To LogOut
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer" style="text-align: center;">
                        <button type="button" (click)="logout()" class="btn btn-success btn-success-right"
                            data-dismiss="modal">Confirm</button>
                        <button type="button" class="btn btn-danger btn-danger-right"
                            data-dismiss="modal">Close</button>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
        <p style="color: white">Loading </p>  
        </ngx-spinner>  
</div>